module.exports = __webpack_public_path__ + "img/logo.08780482.svg";